import { createContext, useContext, useState, useEffect } from "react";

const SearchContext = createContext(null);
const KEY = "interko_search_state";

const EMPTY = { query: "", result: null, view: "list", minScore: "0", hideInter: false, region: "all", maxKm: "all", includeRemote: false, relatedOnly: false, sortBy: "recent", oppType: "final", tjmMin: "", tjmMax: "", tjmInclUnspec: true, seniority: "all" };

function load() {
  try {
    const raw = sessionStorage.getItem(KEY);
    if (raw) return { ...EMPTY, ...JSON.parse(raw) };
  } catch {
    /* ignore */
  }
  return { ...EMPTY };
}

export function SearchProvider({ children }) {
  const [state, setState] = useState(load);

  useEffect(() => {
    try {
      sessionStorage.setItem(KEY, JSON.stringify(state));
    } catch {
      /* quota / serialization — non blocking */
    }
  }, [state]);

  const set = (patch) => setState((s) => ({ ...s, ...patch }));
  const reset = () => setState({ ...EMPTY });

  return (
    <SearchContext.Provider value={{ ...state, set, reset }}>
      {children}
    </SearchContext.Provider>
  );
}

export const useSearch = () => useContext(SearchContext);
